import { trigger, state, style, transition, animate } from '@angular/animations';

export const FormatExpand = trigger('changeState', [
  state(
    'state2',
    style({
      top: '0px',
      height: '100%',
      width: '100%',
    })
  ),

  transition('*=>state2', animate('0.25s cubic-bezier(.17,.67,.69,.91)')),
]);
